import { InvitePartnerTenantInput } from 'app/types/schema';

export function createInvitePartnerTenantInput(values: any): InvitePartnerTenantInput {
  return {
    emailId: values.emailId.trim(),
    firstName: values.firstName.trim(),
    lastName: values.lastName.trim(),
  };
}
